import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { DBCollectionName } from '../enums';
import { News } from '../models';

@Injectable({ providedIn: 'root' })
export class NewsService extends BaseService<News> {
  constructor(angularFirestore: AngularFirestore) {
    super(DBCollectionName.NEWS, angularFirestore);
  }
}
